import { render, staticRenderFns } from "./ClaimForm.vue?vue&type=template&id=8df70dbc&scoped=true"
import script from "./ClaimForm.vue?vue&type=script&lang=js"
export * from "./ClaimForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df70dbc",
  null
  
)

export default component.exports